module.exports = __webpack_public_path__ + "img/pic19.4a35053f.png";